import { StaticImageData } from "next/image";
// Chauffeur (assets historiques)
import voiture from "@/assets/images/insta/POST_IG_12.jpg";
import post2 from "@/assets/images/insta/POST_IG_2.jpg";
import post3 from "@/assets/images/insta/POST_IG_3.jpg";
import post4 from "@/assets/images/insta/POST_IG_4.jpg";
import post5 from "@/assets/images/insta/POST_IG_5.jpg";
import post6 from "@/assets/images/insta/POST_IG_6.jpg";

// Abarth 500
import abarth500Main from "@/assets/images/location/vehicules/abarth/Abarth-500-01.jpg";
import abarth500Gallery02 from "@/assets/images/location/vehicules/abarth/Abarth-500-02.jpg";
import abarth500Gallery03 from "@/assets/images/location/vehicules/abarth/Abarth-500-03.jpg";
import abarth500Gallery04 from "@/assets/images/location/vehicules/abarth/Abarth-500-04.jpg";
import abarth500Gallery05 from "@/assets/images/location/vehicules/abarth/Abarth-500-05.jpg";
import abarth500Gallery06 from "@/assets/images/location/vehicules/abarth/Abarth-500-06.jpg";
import abarth500Gallery07 from "@/assets/images/location/vehicules/abarth/Abarth-500-07.jpg";
import abarth500Gallery08 from "@/assets/images/location/vehicules/abarth/Abarth-500-08.jpg";
import abarth500Gallery09 from "@/assets/images/location/vehicules/abarth/Abarth-500-09.jpg";
import abarth500Gallery10 from "@/assets/images/location/vehicules/abarth/Abarth-500-10.jpg";
import abarth500Gallery11 from "@/assets/images/location/vehicules/abarth/Abarth-500-11.jpg";
import abarth500Gallery12 from "@/assets/images/location/vehicules/abarth/Abarth-500-12.jpg";
import abarth500Gallery13 from "@/assets/images/location/vehicules/abarth/Abarth-500-13.jpg";
import abarth500Gallery14 from "@/assets/images/location/vehicules/abarth/Abarth-500-14.jpg";
import abarth500Gallery15 from "@/assets/images/location/vehicules/abarth/Abarth-500-15.jpg";
import abarth500Gallery16 from "@/assets/images/location/vehicules/abarth/Abarth-500-16.jpg";
import abarth500Gallery17 from "@/assets/images/location/vehicules/abarth/Abarth-500-17.jpg";

// MINI JCW CAB
import miniJcwMain from "@/assets/images/location/vehicules/mini jcw cab/mini-jcw-cab-1.png";
import miniJcwGallery02 from "@/assets/images/location/vehicules/mini jcw cab/mini-jcw-cab-02.webp";
import miniJcwGallery03 from "@/assets/images/location/vehicules/mini jcw cab/mini-jcw-cab-03.webp";
import miniJcwGallery04 from "@/assets/images/location/vehicules/mini jcw cab/mini-jcw-cab-04.webp";
import miniJcwGallery05 from "@/assets/images/location/vehicules/mini jcw cab/mini-jcw-cab-05.webp";
import miniJcwGallery06 from "@/assets/images/location/vehicules/mini jcw cab/mini-jcw-cab-06.webp";
import miniJcwGallery07 from "@/assets/images/location/vehicules/mini jcw cab/mini-jcw-cab-07.webp";
import miniJcwGallery08 from "@/assets/images/location/vehicules/mini jcw cab/mini-jcw-cab-08.png";
import miniJcwGallery09 from "@/assets/images/location/vehicules/mini jcw cab/mini-jcw-cab-09.png";
import miniJcwGallery10 from "@/assets/images/location/vehicules/mini jcw cab/mini-jcw-cab-10.png";
import miniJcwGallery11 from "@/assets/images/location/vehicules/mini jcw cab/mini-jcw-cab-11.jpg";

// VW GOLF 8R
import vwGolf8rMain from "@/assets/images/location/vehicules/VW golf 8R/vw-golf-8r-01.jpg";
import vwGolf8rGallery02 from "@/assets/images/location/vehicules/VW golf 8R/vw-golf-8r-02.jpg";
import vwGolf8rGallery03 from "@/assets/images/location/vehicules/VW golf 8R/vw-golf-8r-03.jpg";
import vwGolf8rGallery04 from "@/assets/images/location/vehicules/VW golf 8R/vw-golf-8r-04.webp";
import vwGolf8rGallery05Jpg from "@/assets/images/location/vehicules/VW golf 8R/vw-golf-8r-05.jpg";
import vwGolf8rGallery05Webp from "@/assets/images/location/vehicules/VW golf 8R/vw-golf-8r-05.webp";
import vwGolf8rGallery06 from "@/assets/images/location/vehicules/VW golf 8R/vw-golf-8r-06.webp";
import vwGolf8rGallery07 from "@/assets/images/location/vehicules/VW golf 8R/vw-golf-8r-07.webp";
import vwGolf8rGallery08 from "@/assets/images/location/vehicules/VW golf 8R/vw-golf-8r-08.webp";
import vwGolf8rGallery09 from "@/assets/images/location/vehicules/VW golf 8R/vw-golf-8r-09.webp";
import vwGolf8rGallery10 from "@/assets/images/location/vehicules/VW golf 8R/vw-golf-8r-10.jpg";
import vwGolf8rGallery11 from "@/assets/images/location/vehicules/VW golf 8R/vw-golf-8r-11.jpg";
import vwGolf8rGallery12 from "@/assets/images/location/vehicules/VW golf 8R/vw-golf-8r-12.jpg";
import vwGolf8rGallery13 from "@/assets/images/location/vehicules/VW golf 8R/vw-golf-8r-13.jpg";
import vwGolf8rGallery14 from "@/assets/images/location/vehicules/VW golf 8R/vw-golf-8r-14.jpg";

// MERCEDES CLE CAB
import mercedesCleCabMain from "@/assets/images/location/vehicules/mercedes cle cab/mercedes-cle-cab-01.jpg";
import mercedesCleCabGallery02 from "@/assets/images/location/vehicules/mercedes cle cab/mercedes-cle-cab-02.jpg";
import mercedesCleCabGallery03 from "@/assets/images/location/vehicules/mercedes cle cab/mercedes-cle-cab-03.jpg";
import mercedesCleCabGallery04 from "@/assets/images/location/vehicules/mercedes cle cab/mercedes-cle-cab-04.jpg";
import mercedesCleCabGallery05 from "@/assets/images/location/vehicules/mercedes cle cab/mercedes-cle-cab-05.jpeg";
import mercedesCleCabGallery06 from "@/assets/images/location/vehicules/mercedes cle cab/mercedes-cle-cab-06.jpg";
import mercedesCleCabGallery07 from "@/assets/images/location/vehicules/mercedes cle cab/mercedes-cle-cab-07.jpeg";
import mercedesCleCabGallery08 from "@/assets/images/location/vehicules/mercedes cle cab/mercedes-cle-cab-08.jpg";
import mercedesCleCabGallery09 from "@/assets/images/location/vehicules/mercedes cle cab/mercedes-cle-cab-09.jpg";

// AUDI A5 CABRIOLET
import audiA5CabMain from "@/assets/images/location/vehicules/audi A5 cabriolet/audi-a5-cabriolet-01.jpg";
import audiA5CabGallery02 from "@/assets/images/location/vehicules/audi A5 cabriolet/audi-a5-cabriolet-02.jpg";
import audiA5CabGallery03 from "@/assets/images/location/vehicules/audi A5 cabriolet/audi-a5-cabriolet-03.jpg";
import audiA5CabGallery04 from "@/assets/images/location/vehicules/audi A5 cabriolet/audi-a5-cabriolet-04.avif";
import audiA5CabGallery05 from "@/assets/images/location/vehicules/audi A5 cabriolet/audi-a5-cabriolet-05.jpg";

// BMW SERIE 4 CAB
import bmwSerie4CabMain from "@/assets/images/location/vehicules/bwm serie 4 cab/bwm-serie-4-cab-01.jpg";
import bmwSerie4CabGallery02 from "@/assets/images/location/vehicules/bwm serie 4 cab/bwm-serie-4-cab-02.jpg";
import bmwSerie4CabGallery03 from "@/assets/images/location/vehicules/bwm serie 4 cab/bwm-serie-4-cab-03.jpg";
import bmwSerie4CabGallery04 from "@/assets/images/location/vehicules/bwm serie 4 cab/bwm-serie-4-cab-04.jpg";
import bmwSerie4CabGallery05 from "@/assets/images/location/vehicules/bwm serie 4 cab/bwm-serie-4-cab-05.webp";
import bmwSerie4CabGallery06 from "@/assets/images/location/vehicules/bwm serie 4 cab/bwm-serie-4-cab-06.webp";
import bmwSerie4CabGallery07 from "@/assets/images/location/vehicules/bwm serie 4 cab/bwm-serie-4-cab-07.jpg";
import bmwSerie4CabGallery08 from "@/assets/images/location/vehicules/bwm serie 4 cab/bwm-serie-4-cab-08.jpg";
import bmwSerie4CabGallery09 from "@/assets/images/location/vehicules/bwm serie 4 cab/bwm-serie-4-cab-09.jpg";
import bmwSerie4CabGallery10 from "@/assets/images/location/vehicules/bwm serie 4 cab/bwm-serie-4-cab-10.webp";
import bmwSerie4CabGallery11 from "@/assets/images/location/vehicules/bwm serie 4 cab/bwm-serie-4-cab-11.jpg";
import bmwSerie4CabGallery12 from "@/assets/images/location/vehicules/bwm serie 4 cab/bwm-serie-4-cab-12.webp";
import bmwSerie4CabGallery13 from "@/assets/images/location/vehicules/bwm serie 4 cab/bwm-serie-4-cab-13.jpg";
import bmwSerie4CabGallery14 from "@/assets/images/location/vehicules/bwm serie 4 cab/bwm-serie-4-cab-14.jpg";
import bmwSerie4CabGallery15 from "@/assets/images/location/vehicules/bwm serie 4 cab/bwm-serie-4-cab-15.jpg";

// MERCEDES CLE CABRIOLET AMG
import mercedesCleAmgMain from "@/assets/images/location/vehicules/mercedes cle cabriolet amg/mercedes-cle-cabriolet-amg-01.jpeg";
import mercedesCleAmgGallery02 from "@/assets/images/location/vehicules/mercedes cle cabriolet amg/mercedes-cle-cabriolet-amg-02.jpeg";
import mercedesCleAmgGallery03 from "@/assets/images/location/vehicules/mercedes cle cabriolet amg/mercedes-cle-cabriolet-amg-03.jpeg";
import mercedesCleAmgGallery04 from "@/assets/images/location/vehicules/mercedes cle cabriolet amg/mercedes-cle-cabriolet-amg-04.jpeg";
import mercedesCleAmgGallery05 from "@/assets/images/location/vehicules/mercedes cle cabriolet amg/mercedes-cle-cabriolet-amg-05.jpeg";
import mercedesCleAmgGallery06 from "@/assets/images/location/vehicules/mercedes cle cabriolet amg/mercedes-cle-cabriolet-amg-06.jpeg";

// PORSCHE MACAN GTS
import porscheMacanMain from "@/assets/images/location/vehicules/porsche macan gts/porsche-macan-01.jpg";
import porscheMacanGallery02 from "@/assets/images/location/vehicules/porsche macan gts/porsche-macan-02.jpg";
import porscheMacanGallery03 from "@/assets/images/location/vehicules/porsche macan gts/porsche-macan-03.jpg";
import porscheMacanGallery04 from "@/assets/images/location/vehicules/porsche macan gts/porsche-macan-04.jpg";
import porscheMacanGallery05 from "@/assets/images/location/vehicules/porsche macan gts/porsche-macan-05.jpg";
import porscheMacanGallery06 from "@/assets/images/location/vehicules/porsche macan gts/porsche-macan-06.jpg";
import porscheMacanGallery07 from "@/assets/images/location/vehicules/porsche macan gts/porsche-macan-07.jpg";
import porscheMacanGallery08 from "@/assets/images/location/vehicules/porsche macan gts/porsche-macan-08.jpg";
import porscheMacanGallery09 from "@/assets/images/location/vehicules/porsche macan gts/porsche-macan-09.jpg";
import porscheMacanGallery10 from "@/assets/images/location/vehicules/porsche macan gts/porsche-macan-10.jpg";
import porscheMacanGallery11 from "@/assets/images/location/vehicules/porsche macan gts/porsche-macan-11.jpg";
import porscheMacanGallery12 from "@/assets/images/location/vehicules/porsche macan gts/porsche-macan-12.jpg";

// AUDI RS3 2026
import audiRs3Main from "@/assets/images/location/vehicules/Audi RS3 2026/audi-rs3-2026-01.jpg";
import audiRs3Gallery02 from "@/assets/images/location/vehicules/Audi RS3 2026/audi-rs3-2026-02.jpg";
import audiRs3Gallery03 from "@/assets/images/location/vehicules/Audi RS3 2026/audi-rs3-2026-03.jpg";
import audiRs3Gallery04 from "@/assets/images/location/vehicules/Audi RS3 2026/audi-rs3-2026-04.jpg";
import audiRs3Gallery05 from "@/assets/images/location/vehicules/Audi RS3 2026/audi-rs3-2026-05.jpg";
import audiRs3Gallery06 from "@/assets/images/location/vehicules/Audi RS3 2026/audi-rs3-2026-06.jpg";
import audiRs3Gallery07 from "@/assets/images/location/vehicules/Audi RS3 2026/audi-rs3-2026-07.jpg";
import audiRs3Gallery08 from "@/assets/images/location/vehicules/Audi RS3 2026/audi-rs3-2026-08.jpg";
import audiRs3Gallery09 from "@/assets/images/location/vehicules/Audi RS3 2026/audi-rs3-2026-09.jpg";
import audiRs3Gallery10 from "@/assets/images/location/vehicules/Audi RS3 2026/audi-rs3-2026-10.jpg";
import audiRs3Gallery11 from "@/assets/images/location/vehicules/Audi RS3 2026/audi-rs3-2026-11.jpg";
import audiRs3Gallery12 from "@/assets/images/location/vehicules/Audi RS3 2026/audi-rs3-2026-12.jpg";
import audiRs3Gallery13 from "@/assets/images/location/vehicules/Audi RS3 2026/audi-rs3-2026-13.jpg";
import audiRs3Gallery14 from "@/assets/images/location/vehicules/Audi RS3 2026/audi-rs3-2026-14.jpg";
import audiRs3Gallery15 from "@/assets/images/location/vehicules/Audi RS3 2026/audi-rs3-2026-15.jpg";
import audiRs3Gallery16 from "@/assets/images/location/vehicules/Audi RS3 2026/audi-rs3-2026-16.jpg";
import audiRs3Gallery17 from "@/assets/images/location/vehicules/Audi RS3 2026/audi-rs3-2026-17.jpg";

// MERCEDES GLS 400D
import mercedesGlsMain from "@/assets/images/location/vehicules/mecedes gls 400d/mecedes-gls-400d-01.avif";
import mercedesGlsGallery02 from "@/assets/images/location/vehicules/mecedes gls 400d/mecedes-gls-400d-02.avif";
import mercedesGlsGallery03 from "@/assets/images/location/vehicules/mecedes gls 400d/mecedes-gls-400d-03.avif";
import mercedesGlsGallery04 from "@/assets/images/location/vehicules/mecedes gls 400d/mecedes-gls-400d-04.webp";
import mercedesGlsGallery05 from "@/assets/images/location/vehicules/mecedes gls 400d/mecedes-gls-400d-05.avif";
import mercedesGlsGallery06 from "@/assets/images/location/vehicules/mecedes gls 400d/mecedes-gls-400d-06.avif";

// ROLLS ROYCE CULLINAN
import rollsCullinanMain from "@/assets/images/location/vehicules/rollss royce cullinan/rollss-royce-cullinan-01.jpg";
import rollsCullinanGallery02 from "@/assets/images/location/vehicules/rollss royce cullinan/rollss-royce-cullinan-02.webp";
import rollsCullinanGallery03 from "@/assets/images/location/vehicules/rollss royce cullinan/rollss-royce-cullinan-03.webp";
import rollsCullinanGallery04 from "@/assets/images/location/vehicules/rollss royce cullinan/rollss-royce-cullinan-04.webp";
import rollsCullinanGallery05 from "@/assets/images/location/vehicules/rollss royce cullinan/rollss-royce-cullinan-5.webp";
import rollsCullinanGallery06 from "@/assets/images/location/vehicules/rollss royce cullinan/rollss-royce-cullinan-06.webp";
import rollsCullinanGallery07 from "@/assets/images/location/vehicules/rollss royce cullinan/rollss-royce-cullinan-07.jpg";
import rollsCullinanGallery08 from "@/assets/images/location/vehicules/rollss royce cullinan/rollss-royce-cullinan-08.jpg";
import rollsCullinanGallery09 from "@/assets/images/location/vehicules/rollss royce cullinan/rollss-royce-cullinan-09.jpg";
import rollsCullinanGallery10 from "@/assets/images/location/vehicules/rollss royce cullinan/rollss-royce-cullinan-10.jpg";
import rollsCullinanGallery11 from "@/assets/images/location/vehicules/rollss royce cullinan/rollss-royce-cullinan-11.jpg";

// MERCEDES S-CLASS LONG
import mercedesSClassMain from "@/assets/images/location/vehicules/mercedes s-class long/mercedes-s-class-long-01.avif";
import mercedesSClassGallery02 from "@/assets/images/location/vehicules/mercedes s-class long/mercedes-s-class-long-02.avif";
import mercedesSClassGallery03 from "@/assets/images/location/vehicules/mercedes s-class long/mercedes-s-class-long-03.jpg";
import mercedesSClassGallery04 from "@/assets/images/location/vehicules/mercedes s-class long/mercedes-s-class-long-04.jpg";
import mercedesSClassGallery05 from "@/assets/images/location/vehicules/mercedes s-class long/mercedes-s-class-long-05.jpg";
import mercedesSClassGallery06 from "@/assets/images/location/vehicules/mercedes s-class long/mercedes-s-class-long-06.jpg";
import mercedesSClassGallery07 from "@/assets/images/location/vehicules/mercedes s-class long/mercedes-s-class-long-07.jpg";
import mercedesSClassGallery08 from "@/assets/images/location/vehicules/mercedes s-class long/mercedes-s-class-long-08.jpg";
import mercedesSClassGallery09 from "@/assets/images/location/vehicules/mercedes s-class long/mercedes-s-class-long-09.jpg";
import mercedesSClassGallery10 from "@/assets/images/location/vehicules/mercedes s-class long/mercedes-s-class-long-10.jpg";
import mercedesSClassGallery11 from "@/assets/images/location/vehicules/mercedes s-class long/mercedes-s-class-long-11.jpg";

// RANGE ROVER SPORT
import rangeRoverSportMain from "@/assets/images/location/vehicules/range rover sport/range-rover-sport-01.jpg";
import rangeRoverSportGallery02 from "@/assets/images/location/vehicules/range rover sport/range-rover-sport-02.jpg";
import rangeRoverSportGallery03 from "@/assets/images/location/vehicules/range rover sport/range-rover-sport-03.jpg";
import rangeRoverSportGallery04 from "@/assets/images/location/vehicules/range rover sport/range-rover-sport-04.jpg";
import rangeRoverSportGallery05 from "@/assets/images/location/vehicules/range rover sport/range-rover-sport-05.avif";
import rangeRoverSportGallery06 from "@/assets/images/location/vehicules/range rover sport/range-rover-sport-06.avif";

// PORSCHE CAYENNE TURBO S
import porscheCayenneMain from "@/assets/images/location/vehicules/porsche cayenne turbo s/porsche-cayenne-turbo-s-01.jpg";
import porscheCayenneGallery02 from "@/assets/images/location/vehicules/porsche cayenne turbo s/porsche-cayenne-turbo-s-02.jpg";
import porscheCayenneGallery03 from "@/assets/images/location/vehicules/porsche cayenne turbo s/porsche-cayenne-turbo-s-03.jpg";
import porscheCayenneGallery04 from "@/assets/images/location/vehicules/porsche cayenne turbo s/porsche-cayenne-turbo-s-04.jpg";
import porscheCayenneGallery05 from "@/assets/images/location/vehicules/porsche cayenne turbo s/porsche-cayenne-turbo-s-05.jpg";
import porscheCayenneGallery06 from "@/assets/images/location/vehicules/porsche cayenne turbo s/porsche-cayenne-turbo-s-06.jpg";
import porscheCayenneGallery07 from "@/assets/images/location/vehicules/porsche cayenne turbo s/porsche-cayenne-turbo-s-07.jpg";
import porscheCayenneGallery08 from "@/assets/images/location/vehicules/porsche cayenne turbo s/porsche-cayenne-turbo-s-08.jpg";
import porscheCayenneGallery09 from "@/assets/images/location/vehicules/porsche cayenne turbo s/porsche-cayenne-turbo-s-09.jpg";
import porscheCayenneGallery10 from "@/assets/images/location/vehicules/porsche cayenne turbo s/porsche-cayenne-turbo-s-10.jpg";

// MASERATI GRANCABRIO
import maseratiGrancabrioMain from "@/assets/images/location/vehicules/maserati grandcabrio/maserati-grandcabrio-01.jpg";
import maseratiGrancabrioGallery02 from "@/assets/images/location/vehicules/maserati grandcabrio/maserati-grandcabrio-02.jpg";
import maseratiGrancabrioGallery03 from "@/assets/images/location/vehicules/maserati grandcabrio/maserati-grandcabrio-03.webp";
import maseratiGrancabrioGallery04 from "@/assets/images/location/vehicules/maserati grandcabrio/maserati-grandcabrio-04.webp";
import maseratiGrancabrioGallery05 from "@/assets/images/location/vehicules/maserati grandcabrio/maserati-grandcabrio-05.webp";

// AUDI RS6
import audiRs6Main from "@/assets/images/location/vehicules/Audi RS6/audi-rs6-01.jpg";
import audiRs6Gallery02 from "@/assets/images/location/vehicules/Audi RS6/audi-rs6-02.jpg";
import audiRs6Gallery03 from "@/assets/images/location/vehicules/Audi RS6/audi-rs6-03.avif";
import audiRs6Gallery04 from "@/assets/images/location/vehicules/Audi RS6/audi-rs6-04.avif";
import audiRs6Gallery05 from "@/assets/images/location/vehicules/Audi RS6/audi-rs6-05.avif";
import audiRs6Gallery06 from "@/assets/images/location/vehicules/Audi RS6/audi-rs6-06.avif";
import audiRs6Gallery07 from "@/assets/images/location/vehicules/Audi RS6/audi-rs6-07.jpg";
import audiRs6Gallery08 from "@/assets/images/location/vehicules/Audi RS6/audi-rs6-08.jpg";
import audiRs6Gallery09 from "@/assets/images/location/vehicules/Audi RS6/audi-rs6-09.jpg";
import audiRs6Gallery10 from "@/assets/images/location/vehicules/Audi RS6/audi-rs6-10.jpg";
import audiRs6Gallery11 from "@/assets/images/location/vehicules/Audi RS6/audi-rs6-11.jpg";

// MERCEDES G63 AMG
import mercedesG63Main from "@/assets/images/location/vehicules/mercedes g63 amg/mercedes-g63-amg-01.jpg";
import mercedesG63Gallery02 from "@/assets/images/location/vehicules/mercedes g63 amg/mercedes-g63-amg-02.jpg";
import mercedesG63Gallery03 from "@/assets/images/location/vehicules/mercedes g63 amg/mercedes-g63-amg-03.jpg";
import mercedesG63Gallery04 from "@/assets/images/location/vehicules/mercedes g63 amg/mercedes-g63-amg-04.jpg";
import mercedesG63Gallery05 from "@/assets/images/location/vehicules/mercedes g63 amg/mercedes-g63-amg-05.jpg";

// PORSCHE 911 4S
import porsche911Main from "@/assets/images/location/vehicules/porsche 911 4s/porsche-911-4s-01.jpg";
import porsche911Gallery02 from "@/assets/images/location/vehicules/porsche 911 4s/porsche-911-4s-02.jpg";
import porsche911Gallery03 from "@/assets/images/location/vehicules/porsche 911 4s/porsche-911-4s-03.jpg";
import porsche911Gallery04 from "@/assets/images/location/vehicules/porsche 911 4s/porsche-911-4s-04.avif";
import porsche911Gallery05 from "@/assets/images/location/vehicules/porsche 911 4s/porsche-911-4s-05.jpg";
import porsche911Gallery06 from "@/assets/images/location/vehicules/porsche 911 4s/porsche-911-4s-06.jpg";
import porsche911Gallery07 from "@/assets/images/location/vehicules/porsche 911 4s/porsche-911-4s-07.jpg";
import porsche911Gallery08 from "@/assets/images/location/vehicules/porsche 911 4s/porsche-911-4s-08.jpg";

// AUDI R8 CAB
import audiR8Main from "@/assets/images/location/vehicules/Audi R8 cab/audi-r8-cab-01.jpg";
import audiR8Gallery02 from "@/assets/images/location/vehicules/Audi R8 cab/audi-r8-cab-02.jpg";
import audiR8Gallery03 from "@/assets/images/location/vehicules/Audi R8 cab/audi-r8-cab-03.jpg";
import audiR8Gallery04 from "@/assets/images/location/vehicules/Audi R8 cab/audi-r8-cab-04.jpg";
import audiR8Gallery05 from "@/assets/images/location/vehicules/Audi R8 cab/audi-r8-cab-05.jpg";
import audiR8Gallery06 from "@/assets/images/location/vehicules/Audi R8 cab/audi-r8-cab-06.jpg";
import audiR8Gallery07 from "@/assets/images/location/vehicules/Audi R8 cab/audi-r8-cab-07.jpg";
import audiR8Gallery08 from "@/assets/images/location/vehicules/Audi R8 cab/audi-r8-cab-08.jpg";
import audiR8Gallery09 from "@/assets/images/location/vehicules/Audi R8 cab/audi-r8-cab-09.jpg";
import audiR8Gallery10 from "@/assets/images/location/vehicules/Audi R8 cab/audi-r8-cab-10.jpg";

// FERRARI 296 GTS
import ferrari296Main from "@/assets/images/location/vehicules/Ferrari 296 GTS/ferrari-296-gts-01.jpg";
import ferrari296Gallery02 from "@/assets/images/location/vehicules/Ferrari 296 GTS/ferrari-296-gts-02.avif";
import ferrari296Gallery03 from "@/assets/images/location/vehicules/Ferrari 296 GTS/ferrari-296-gts-03.avif";
import ferrari296Gallery04 from "@/assets/images/location/vehicules/Ferrari 296 GTS/ferrari-296-gts-04.jpg";
import ferrari296Gallery05 from "@/assets/images/location/vehicules/Ferrari 296 GTS/ferrari-296-gts-05.avif";
import ferrari296Gallery06 from "@/assets/images/location/vehicules/Ferrari 296 GTS/ferrari-296-gts-06.jpeg";

// G800 BRABUS
import mercedesG800Main from "@/assets/images/location/vehicules/G800 Brabus/g800-brabus-01.jpg";
import mercedesG800Gallery02 from "@/assets/images/location/vehicules/G800 Brabus/g800-brabus-02.webp";
import mercedesG800Gallery03 from "@/assets/images/location/vehicules/G800 Brabus/g800-brabus-03.jpg";
import mercedesG800Gallery04 from "@/assets/images/location/vehicules/G800 Brabus/g800-brabus-04.webp";
import mercedesG800Gallery05 from "@/assets/images/location/vehicules/G800 Brabus/g800-brabus-05.webp";
import mercedesG800Gallery06 from "@/assets/images/location/vehicules/G800 Brabus/g800-brabus-06.webp";
import mercedesG800Gallery07 from "@/assets/images/location/vehicules/G800 Brabus/g800-brabus-07.webp";
import mercedesG800Gallery08 from "@/assets/images/location/vehicules/G800 Brabus/g800-brabus-08.webp";
import mercedesG800Gallery09 from "@/assets/images/location/vehicules/G800 Brabus/g800-brabus-09.webp";

// LAMBORGHINI URUS
import lamboUrusMain from "@/assets/images/location/vehicules/Lambo Urus/lambo-urus-01.jpg";
import lamboUrusGallery02 from "@/assets/images/location/vehicules/Lambo Urus/lambo-urus-02.jpg";
import lamboUrusGallery03 from "@/assets/images/location/vehicules/Lambo Urus/lambo-urus-03.jpg";
import lamboUrusGallery04 from "@/assets/images/location/vehicules/Lambo Urus/lambo-urus-04.jpg";
import lamboUrusGallery05 from "@/assets/images/location/vehicules/Lambo Urus/lambo-urus-05.jpg";
import lamboUrusGallery06 from "@/assets/images/location/vehicules/Lambo Urus/lambo-urus-06.jpg";

// LAMBORGHINI REVUELTO
import lamboRevueltoMain from "@/assets/images/location/vehicules/lambo revuelto/lambo-revuelto-01.jpeg";
import lamboRevueltoGallery02 from "@/assets/images/location/vehicules/lambo revuelto/lambo-revuelto-02.jpeg";
import lamboRevueltoGallery03 from "@/assets/images/location/vehicules/lambo revuelto/lambo-revuelto-03.jpeg";
import lamboRevueltoGallery04 from "@/assets/images/location/vehicules/lambo revuelto/lambo-revuelto-04.jpeg";
import lamboRevueltoGallery05 from "@/assets/images/location/vehicules/lambo revuelto/lambo-revuelto-05.jpeg";
import lamboRevueltoGallery06 from "@/assets/images/location/vehicules/lambo revuelto/lambo-revuelto-06.jpeg";
import lamboRevueltoGallery07 from "@/assets/images/location/vehicules/lambo revuelto/lambo-revuelto-07.jpeg";
import lamboRevueltoGallery08 from "@/assets/images/location/vehicules/lambo revuelto/lambo-revuelto-08.jpeg";
import lamboRevueltoGallery09 from "@/assets/images/location/vehicules/lambo revuelto/lambo-revuelto-09.jpeg";
import lamboRevueltoGallery10 from "@/assets/images/location/vehicules/lambo revuelto/lambo-revuelto-10.jpeg";

// LAMBO HURACAN EVO SPYDER
import lamboHuracanMain from "@/assets/images/location/vehicules/Lambo Hurracan Evo Spyder/lambo-hurracan-evo-spyder-01.jpg";
import lamboHuracanGallery02 from "@/assets/images/location/vehicules/Lambo Hurracan Evo Spyder/lambo-hurracan-evo-spyder-02.jpg";
import lamboHuracanGallery03 from "@/assets/images/location/vehicules/Lambo Hurracan Evo Spyder/lambo-hurracan-evo-spyder-03.jpg";
import lamboHuracanGallery04 from "@/assets/images/location/vehicules/Lambo Hurracan Evo Spyder/lambo-hurracan-evo-spyder-04.jpg";
import lamboHuracanGallery05 from "@/assets/images/location/vehicules/Lambo Hurracan Evo Spyder/lambo-hurracan-evo-spyder-05.jpg";
import lamboHuracanGallery06 from "@/assets/images/location/vehicules/Lambo Hurracan Evo Spyder/lambo-hurracan-evo-spyder-06.jpg";
import lamboHuracanGallery07 from "@/assets/images/location/vehicules/Lambo Hurracan Evo Spyder/lambo-hurracan-evo-spyder-07.webp";

export type PriceType = {
  amount: number;
  type: "per_hour" | "per_day";
  km_limit?: number;
  tiers?: RentalPriceTiers;
};

export type RentalPriceTiers = {
  oneToThreeDays: number;
  fourToSixDays: number;
  sevenPlusDays: number;
};

export type VehicleSpecs = {
  year: number;
  mileage: number;
  gearbox: "Automatique" | "Manuelle";
  fuel: "Essence" | "Diesel" | "Hybride" | "Électrique";
  engine: string; // Motorisation
  powerHP: number; // Puissance (ch)
  powerCV: number; // Puissance (cv)
  exteriorColor: string;
  interiorColor: string;
};

export type VehicleFeatures = {
  exterior: string[]; // Extérieur et châssis
  interior: string[]; // Intérieur
  safety: string[]; // Sécurité
  other: string[]; // Autres
};

export type Vehicle = {
  id: string;
  name: string;
  brand: string;
  specs: VehicleSpecs;
  features: VehicleFeatures;
  price: PriceType;
  images: {
    main: StaticImageData;
    gallery: StaticImageData[];
  };
  isNew?: boolean;
  withDriver?: boolean;
};

// Données de base pour les features (pour éviter la répétition)
const commonFeatures: VehicleFeatures = {
  exterior: [
    "Jantes en alliage 19 pouces",
    "Phares LED adaptatifs",
    "Toit ouvrant panoramique",
  ],
  interior: [
    "Sièges sport en cuir",
    "Système audio premium",
    "Climatisation automatique 4 zones",
  ],
  safety: [
    "Freinage d'urgence automatique",
    "Régulateur de vitesse adaptatif",
    "Surveillance des angles morts",
  ],
  other: ["Connectivité Bluetooth", "Navigation GPS", "Caméra de recul"],
};

// Véhicules avec chauffeur
const RENTAL_PRICE_TIERS_BY_BASE: Record<number, RentalPriceTiers> = {
  250: { oneToThreeDays: 250, fourToSixDays: 220, sevenPlusDays: 180 },
  300: { oneToThreeDays: 300, fourToSixDays: 270, sevenPlusDays: 220 },
  350: { oneToThreeDays: 350, fourToSixDays: 270, sevenPlusDays: 240 },
  450: { oneToThreeDays: 450, fourToSixDays: 410, sevenPlusDays: 360 },
  600: { oneToThreeDays: 600, fourToSixDays: 530, sevenPlusDays: 480 },
  650: { oneToThreeDays: 650, fourToSixDays: 590, sevenPlusDays: 520 },
  850: { oneToThreeDays: 850, fourToSixDays: 790, sevenPlusDays: 680 },
  900: { oneToThreeDays: 900, fourToSixDays: 850, sevenPlusDays: 790 },
  1050: { oneToThreeDays: 1050, fourToSixDays: 950, sevenPlusDays: 900 },
  1100: { oneToThreeDays: 1100, fourToSixDays: 1000, sevenPlusDays: 900 },
  2000: { oneToThreeDays: 2000, fourToSixDays: 1700, sevenPlusDays: 1500 },
  2200: { oneToThreeDays: 2200, fourToSixDays: 2000, sevenPlusDays: 1800 },
  3000: { oneToThreeDays: 3000, fourToSixDays: 2700, sevenPlusDays: 2500 },
  3200: { oneToThreeDays: 3200, fourToSixDays: 3000, sevenPlusDays: 2800 },
};

const buildRentalPrice = (
  oneToThreeDays: number,
  km_limit = 200,
): PriceType => {
  const tiers = RENTAL_PRICE_TIERS_BY_BASE[oneToThreeDays] ?? {
    oneToThreeDays,
    fourToSixDays: oneToThreeDays,
    sevenPlusDays: oneToThreeDays,
  };
  return {
    amount: oneToThreeDays,
    type: "per_day",
    km_limit,
    tiers,
  };
};

export const DRIVER_VEHICLES: Vehicle[] = [
  {
    id: "mercedes-c-class",
    name: "MERCEDES C-CLASS",
    brand: "Mercedes",
    specs: {
      year: 2023,
      mileage: 3240,
      gearbox: "Automatique",
      fuel: "Hybride",
      engine: "C200 2.0L 4-cylindres",
      powerHP: 204,
      powerCV: 15,
      exteriorColor: "Noir Obsidienne",
      interiorColor: "Cuir noir",
    },
    features: commonFeatures,
    price: {
      amount: 60,
      type: "per_hour",
    },
    images: {
      main: post2,
      gallery: [post2, post3],
    },
    withDriver: true,
  },
  {
    id: "mercedes-e-class",
    name: "MERCEDES E-CLASS",
    brand: "Mercedes",
    specs: {
      year: 2023,
      mileage: 5100,
      gearbox: "Automatique",
      fuel: "Hybride",
      engine: "E300e 2.0L 4-cylindres",
      powerHP: 320,
      powerCV: 17,
      exteriorColor: "Gris Sélénite",
      interiorColor: "Cuir beige",
    },
    features: commonFeatures,
    price: {
      amount: 80,
      type: "per_hour",
    },
    images: {
      main: post3,
      gallery: [post3, post4],
    },
    withDriver: true,
  },
  {
    id: "mercedes-s-class-long",
    name: "MERCEDES S-CLASS LONG",
    brand: "Mercedes",
    specs: {
      year: 2023,
      mileage: 2800,
      gearbox: "Automatique",
      fuel: "Hybride",
      engine: "S500 3.0L 6-cylindres",
      powerHP: 435,
      powerCV: 24,
      exteriorColor: "Noir Diamant",
      interiorColor: "Cuir nappa beige",
    },
    features: commonFeatures,
    price: {
      amount: 150,
      type: "per_hour",
    },
    images: {
      main: post4,
      gallery: [post4, post5],
    },
    withDriver: true,
  },
  {
    id: "range-rover-sport-driver",
    name: "RANGE ROVER SPORT",
    brand: "Range Rover",
    specs: {
      year: 2023,
      mileage: 4200,
      gearbox: "Automatique",
      fuel: "Hybride",
      engine: "P400e 2.0L 4-cylindres",
      powerHP: 404,
      powerCV: 22,
      exteriorColor: "Gris Carpathian",
      interiorColor: "Cuir noir",
    },
    features: commonFeatures,
    price: {
      amount: 130,
      type: "per_hour",
    },
    images: {
      main: post5,
      gallery: [post5, post6],
    },
    withDriver: true,
  },
  {
    id: "mercedes-v-class-xl",
    name: "MERCEDES V-CLASS XL",
    brand: "Mercedes",
    specs: {
      year: 2023,
      mileage: 6500,
      gearbox: "Automatique",
      fuel: "Diesel",
      engine: "300d 2.0L 4-cylindres",
      powerHP: 237,
      powerCV: 13,
      exteriorColor: "Noir Obsidienne",
      interiorColor: "Cuir nappa noir",
    },
    features: {
      ...commonFeatures,
      interior: [
        ...commonFeatures.interior,
        "Configuration 7 places luxe",
        "Tables escamotables",
      ],
    },
    price: {
      amount: 120,
      type: "per_hour",
    },
    images: {
      main: post6,
      gallery: [post6, post2],
    },
    withDriver: true,
  },
  {
    id: "mercedes-v-class-vip",
    name: "MERCEDES V-CLASS VIP",
    brand: "Mercedes",
    specs: {
      year: 2023,
      mileage: 3800,
      gearbox: "Automatique",
      fuel: "Diesel",
      engine: "300d 2.0L 4-cylindres",
      powerHP: 237,
      powerCV: 13,
      exteriorColor: "Noir Obsidienne",
      interiorColor: "Cuir nappa beige",
    },
    features: {
      ...commonFeatures,
      interior: [
        ...commonFeatures.interior,
        "Configuration 4 places VIP",
        "Bar réfrigéré",
        "Écrans individuels",
      ],
    },
    price: {
      amount: 180,
      type: "per_hour",
    },
    images: {
      main: voiture,
      gallery: [voiture, post2],
    },
    withDriver: true,
  },
  {
    id: "rolls-royce-phantom-8",
    name: "ROLLS ROYCE PHANTOM 8",
    brand: "Rolls-Royce",
    specs: {
      year: 2023,
      mileage: 1200,
      gearbox: "Automatique",
      fuel: "Essence",
      engine: "V12 6.75L",
      powerHP: 571,
      powerCV: 31,
      exteriorColor: "Diamond Black",
      interiorColor: "Cuir blanc",
    },
    features: {
      ...commonFeatures,
      interior: [
        ...commonFeatures.interior,
        "Ciel de toit étoilé",
        "Cave à champagne",
        "Rideaux électriques",
      ],
    },
    price: {
      amount: 500,
      type: "per_hour",
    },
    images: {
      main: post2,
      gallery: [post2, post3],
    },
    withDriver: true,
  },
];

// Véhicules en location
export const RENTAL_VEHICLES: Vehicle[] = [
  {
    id: "mini-jcw-cab",
    name: "MINI JCW CAB",
    brand: "Mini",
    specs: {
      year: 2023,
      mileage: 8500,
      gearbox: "Automatique",
      fuel: "Essence",
      engine: "2.0L 4-cylindres Turbo",
      powerHP: 231,
      powerCV: 13,
      exteriorColor: "Rouge Chili",
      interiorColor: "Cuir noir",
    },
    features: commonFeatures,
    price: buildRentalPrice(300, 200),
    images: {
      main: miniJcwMain,
      gallery: [
        miniJcwGallery02,
        miniJcwGallery03,
        miniJcwGallery04,
        miniJcwGallery05,
        miniJcwGallery06,
        miniJcwGallery07,
        miniJcwGallery08,
        miniJcwGallery09,
        miniJcwGallery10,
        miniJcwGallery11,
      ],
    },
  },
  {
    id: "vw-golf-8r",
    name: "VW GOLF 8R",
    brand: "Volkswagen",
    specs: {
      year: 2023,
      mileage: 7200,
      gearbox: "Automatique",
      fuel: "Essence",
      engine: "2.0L TSI 4-cylindres",
      powerHP: 320,
      powerCV: 17,
      exteriorColor: "Bleu Lapiz",
      interiorColor: "Cuir noir",
    },
    features: commonFeatures,
    price: buildRentalPrice(300, 200),
    images: {
      main: vwGolf8rMain,
      gallery: [
        vwGolf8rGallery02,
        vwGolf8rGallery03,
        vwGolf8rGallery04,
        vwGolf8rGallery05Jpg,
        vwGolf8rGallery05Webp,
        vwGolf8rGallery06,
        vwGolf8rGallery07,
        vwGolf8rGallery08,
        vwGolf8rGallery09,
        vwGolf8rGallery10,
        vwGolf8rGallery11,
        vwGolf8rGallery12,
        vwGolf8rGallery13,
        vwGolf8rGallery14,
      ],
    },
  },
  {
    id: "mercedes-cle-cabriolet",
    name: "MERCEDES CLE CABRIOLET",
    brand: "Mercedes",
    specs: {
      year: 2023,
      mileage: 5600,
      gearbox: "Automatique",
      fuel: "Essence",
      engine: "CLE 300 2.0L 4-cylindres",
      powerHP: 258,
      powerCV: 14,
      exteriorColor: "Blanc Diamant",
      interiorColor: "Cuir rouge",
    },
    features: commonFeatures,
    price: buildRentalPrice(350, 200),
    images: {
      main: mercedesCleCabMain,
      gallery: [
        mercedesCleCabGallery02,
        mercedesCleCabGallery03,
        mercedesCleCabGallery04,
        mercedesCleCabGallery05,
        mercedesCleCabGallery06,
        mercedesCleCabGallery07,
        mercedesCleCabGallery08,
        mercedesCleCabGallery09,
      ],
    },
  },
  {
    id: "audi-a5-cab",
    name: "AUDI A5 CAB",
    brand: "Audi",
    specs: {
      year: 2023,
      mileage: 6100,
      gearbox: "Automatique",
      fuel: "Essence",
      engine: "45 TFSI 2.0L 4-cylindres",
      powerHP: 265,
      powerCV: 14,
      exteriorColor: "Gris Daytona",
      interiorColor: "Cuir brun",
    },
    features: commonFeatures,
    price: buildRentalPrice(350, 200),
    images: {
      main: audiA5CabMain,
      gallery: [
        audiA5CabGallery02,
        audiA5CabGallery03,
        audiA5CabGallery04,
        audiA5CabGallery05,
      ],
    },
  },
  {
    id: "bmw-serie-4-cab",
    name: "BMW SÉRIE 4 CAB",
    brand: "BMW",
    specs: {
      year: 2023,
      mileage: 5900,
      gearbox: "Automatique",
      fuel: "Essence",
      engine: "M440i 3.0L 6-cylindres",
      powerHP: 374,
      powerCV: 20,
      exteriorColor: "Bleu Portimao",
      interiorColor: "Cuir cognac",
    },
    features: commonFeatures,
    price: buildRentalPrice(450, 200),
    images: {
      main: bmwSerie4CabMain,
      gallery: [
        bmwSerie4CabGallery02,
        bmwSerie4CabGallery03,
        bmwSerie4CabGallery04,
        bmwSerie4CabGallery05,
        bmwSerie4CabGallery06,
        bmwSerie4CabGallery07,
        bmwSerie4CabGallery08,
        bmwSerie4CabGallery09,
        bmwSerie4CabGallery10,
        bmwSerie4CabGallery11,
        bmwSerie4CabGallery12,
        bmwSerie4CabGallery13,
        bmwSerie4CabGallery14,
        bmwSerie4CabGallery15,
      ],
    },
  },
  {
    id: "mercedes-cle-cabriolet-amg",
    name: "MERCEDES CLE CABRIOLET AMG",
    brand: "Mercedes",
    specs: {
      year: 2023,
      mileage: 4200,
      gearbox: "Automatique",
      fuel: "Essence",
      engine: "CLE 53 AMG 3.0L 6-cylindres",
      powerHP: 449,
      powerCV: 30,
      exteriorColor: "Argent Iridium",
      interiorColor: "Cuir beige",
    },
    features: commonFeatures,
    price: buildRentalPrice(450, 200),
    images: {
      main: mercedesCleAmgMain,
      gallery: [
        mercedesCleAmgGallery02,
        mercedesCleAmgGallery03,
        mercedesCleAmgGallery04,
        mercedesCleAmgGallery05,
        mercedesCleAmgGallery06,
      ],
    },
  },
  {
    id: "porsche-macan",
    name: "PORSCHE MACAN GTS",
    brand: "Porsche",
    specs: {
      year: 2023,
      mileage: 3800,
      gearbox: "Automatique",
      fuel: "Essence",
      engine: "2.9L V6 biturbo",
      powerHP: 380,
      powerCV: 21,
      exteriorColor: "Bleu Gentiane",
      interiorColor: "Cuir noir",
    },
    features: commonFeatures,
    price: buildRentalPrice(600, 200),
    images: {
      main: porscheMacanMain,
      gallery: [
        porscheMacanGallery02,
        porscheMacanGallery03,
        porscheMacanGallery04,
        porscheMacanGallery05,
        porscheMacanGallery06,
        porscheMacanGallery07,
        porscheMacanGallery08,
        porscheMacanGallery09,
        porscheMacanGallery10,
        porscheMacanGallery11,
        porscheMacanGallery12,
      ],
    },
  },
  {
    id: "audi-rs3-2026",
    name: "AUDI RS3 2026",
    brand: "Audi",
    specs: {
      year: 2026,
      mileage: 4100,
      gearbox: "Automatique",
      fuel: "Essence",
      engine: "2.5L TFSI 5-cylindres",
      powerHP: 400,
      powerCV: 22,
      exteriorColor: "Gris Nardo",
      interiorColor: "Cuir noir",
    },
    features: commonFeatures,
    price: buildRentalPrice(350, 200),
    images: {
      main: audiRs3Main,
      gallery: [
        audiRs3Gallery02,
        audiRs3Gallery03,
        audiRs3Gallery04,
        audiRs3Gallery05,
        audiRs3Gallery06,
        audiRs3Gallery07,
        audiRs3Gallery08,
        audiRs3Gallery09,
        audiRs3Gallery10,
        audiRs3Gallery11,
        audiRs3Gallery12,
        audiRs3Gallery13,
        audiRs3Gallery14,
        audiRs3Gallery15,
        audiRs3Gallery16,
        audiRs3Gallery17,
      ],
    },
  },
  {
    id: "mercedes-gls-400d",
    name: "MERCEDES GLS 400D",
    brand: "Mercedes",
    specs: {
      year: 2023,
      mileage: 5200,
      gearbox: "Automatique",
      fuel: "Diesel",
      engine: "3.0L 6-cylindres",
      powerHP: 330,
      powerCV: 18,
      exteriorColor: "Noir Obsidienne",
      interiorColor: "Cuir marron",
    },
    features: {
      ...commonFeatures,
      interior: [...commonFeatures.interior, "7 places", "Sièges massants"],
    },
    price: buildRentalPrice(650, 200),
    images: {
      main: mercedesGlsMain,
      gallery: [
        mercedesGlsGallery02,
        mercedesGlsGallery03,
        mercedesGlsGallery04,
        mercedesGlsGallery05,
        mercedesGlsGallery06,
      ],
    },
  },
  {
    id: "rolls-royce-cullinan",
    name: "ROLLS ROYCE CULLINAN",
    brand: "Rolls-Royce",
    specs: {
      year: 2023,
      mileage: 3900,
      gearbox: "Automatique",
      fuel: "Essence",
      engine: "6.75L V12",
      powerHP: 571,
      powerCV: 31,
      exteriorColor: "Noir Diamant",
      interiorColor: "Cuir ivoire",
    },
    features: commonFeatures,
    price: buildRentalPrice(3000, 200),
    images: {
      main: rollsCullinanMain,
      gallery: [
        rollsCullinanGallery02,
        rollsCullinanGallery03,
        rollsCullinanGallery04,
        rollsCullinanGallery05,
        rollsCullinanGallery06,
        rollsCullinanGallery07,
        rollsCullinanGallery08,
        rollsCullinanGallery09,
        rollsCullinanGallery10,
        rollsCullinanGallery11,
      ],
    },
  },
  {
    id: "mercedes-s-class-long-rental",
    name: "MERCEDES S-CLASS LONG",
    brand: "Mercedes",
    specs: {
      year: 2023,
      mileage: 2800,
      gearbox: "Automatique",
      fuel: "Hybride",
      engine: "S580e 3.0L 6-cylindres",
      powerHP: 510,
      powerCV: 28,
      exteriorColor: "Gris Sélénite",
      interiorColor: "Cuir beige",
    },
    features: {
      ...commonFeatures,
      interior: [
        ...commonFeatures.interior,
        "Sièges massants",
        "Réfrigérateur",
      ],
    },
    price: buildRentalPrice(650, 200),
    images: {
      main: mercedesSClassMain,
      gallery: [
        mercedesSClassGallery02,
        mercedesSClassGallery03,
        mercedesSClassGallery04,
        mercedesSClassGallery05,
        mercedesSClassGallery06,
        mercedesSClassGallery07,
        mercedesSClassGallery08,
        mercedesSClassGallery09,
        mercedesSClassGallery10,
        mercedesSClassGallery11,
      ],
    },
  },
  {
    id: "range-rover-sport-rental",
    name: "RANGE ROVER SPORT",
    brand: "Range Rover",
    specs: {
      year: 2023,
      mileage: 4500,
      gearbox: "Automatique",
      fuel: "Hybride",
      engine: "P530 4.4L V8",
      powerHP: 530,
      powerCV: 29,
      exteriorColor: "Gris Eiger",
      interiorColor: "Cuir blanc",
    },
    features: commonFeatures,
    price: buildRentalPrice(650, 200),
    images: {
      main: rangeRoverSportMain,
      gallery: [
        rangeRoverSportGallery02,
        rangeRoverSportGallery03,
        rangeRoverSportGallery04,
        rangeRoverSportGallery05,
        rangeRoverSportGallery06,
      ],
    },
  },
  {
    id: "porsche-cayenne-turbo-s",
    name: "PORSCHE CAYENNE TURBO S",
    brand: "Porsche",
    specs: {
      year: 2023,
      mileage: 3200,
      gearbox: "Automatique",
      fuel: "Hybride",
      engine: "4.0L V8 biturbo",
      powerHP: 680,
      powerCV: 37,
      exteriorColor: "Noir Intense",
      interiorColor: "Cuir bordeaux",
    },
    features: commonFeatures,
    price: buildRentalPrice(850, 200),
    images: {
      main: porscheCayenneMain,
      gallery: [
        porscheCayenneGallery02,
        porscheCayenneGallery03,
        porscheCayenneGallery04,
        porscheCayenneGallery05,
        porscheCayenneGallery06,
        porscheCayenneGallery07,
        porscheCayenneGallery08,
        porscheCayenneGallery09,
        porscheCayenneGallery10,
      ],
    },
  },
  {
    id: "maserati-grancabrio",
    name: "MASERATI GRANCABRIO",
    brand: "Maserati",
    specs: {
      year: 2023,
      mileage: 2800,
      gearbox: "Automatique",
      fuel: "Essence",
      engine: "4.7L V8",
      powerHP: 460,
      powerCV: 25,
      exteriorColor: "Blu Nobile",
      interiorColor: "Cuir beige",
    },
    features: commonFeatures,
    price: buildRentalPrice(850, 200),
    images: {
      main: maseratiGrancabrioMain,
      gallery: [
        maseratiGrancabrioGallery02,
        maseratiGrancabrioGallery03,
        maseratiGrancabrioGallery04,
        maseratiGrancabrioGallery05,
      ],
    },
  },
  {
    id: "audi-rs6",
    name: "AUDI RS6",
    brand: "Audi",
    specs: {
      year: 2023,
      mileage: 3600,
      gearbox: "Automatique",
      fuel: "Essence",
      engine: "4.0L V8 biturbo",
      powerHP: 600,
      powerCV: 33,
      exteriorColor: "Gris Nardo",
      interiorColor: "Cuir noir",
    },
    features: commonFeatures,
    price: buildRentalPrice(900, 200),
    images: {
      main: audiRs6Main,
      gallery: [
        audiRs6Gallery02,
        audiRs6Gallery03,
        audiRs6Gallery04,
        audiRs6Gallery05,
        audiRs6Gallery06,
        audiRs6Gallery07,
        audiRs6Gallery08,
        audiRs6Gallery09,
        audiRs6Gallery10,
        audiRs6Gallery11,
      ],
    },
  },
  {
    id: "mercedes-g63-amg",
    name: "MERCEDES G63 AMG",
    brand: "Mercedes",
    specs: {
      year: 2023,
      mileage: 3100,
      gearbox: "Automatique",
      fuel: "Essence",
      engine: "4.0L V8 biturbo",
      powerHP: 585,
      powerCV: 32,
      exteriorColor: "Magno Olive",
      interiorColor: "Cuir marron",
    },
    features: commonFeatures,
    price: buildRentalPrice(900, 200),
    images: {
      main: mercedesG63Main,
      gallery: [
        mercedesG63Gallery02,
        mercedesG63Gallery03,
        mercedesG63Gallery04,
        mercedesG63Gallery05,
      ],
    },
  },
  {
    id: "porsche-911-4s",
    name: "PORSCHE 911 4S",
    brand: "Porsche",
    specs: {
      year: 2023,
      mileage: 2400,
      gearbox: "Automatique",
      fuel: "Essence",
      engine: "3.0L 6-cylindres boxer",
      powerHP: 450,
      powerCV: 25,
      exteriorColor: "Argent GT",
      interiorColor: "Cuir noir",
    },
    features: commonFeatures,
    price: buildRentalPrice(1050, 200),
    images: {
      main: porsche911Main,
      gallery: [
        porsche911Gallery02,
        porsche911Gallery03,
        porsche911Gallery04,
        porsche911Gallery05,
        porsche911Gallery06,
        porsche911Gallery07,
        porsche911Gallery08,
      ],
    },
  },
  {
    id: "audi-r8-cab",
    name: "AUDI R8 CAB",
    brand: "Audi",
    specs: {
      year: 2023,
      mileage: 1800,
      gearbox: "Automatique",
      fuel: "Essence",
      engine: "5.2L V10",
      powerHP: 620,
      powerCV: 34,
      exteriorColor: "Bleu Ara",
      interiorColor: "Cuir noir",
    },
    features: commonFeatures,
    price: buildRentalPrice(1100, 150),
    images: {
      main: audiR8Main,
      gallery: [
        audiR8Gallery02,
        audiR8Gallery03,
        audiR8Gallery04,
        audiR8Gallery05,
        audiR8Gallery06,
        audiR8Gallery07,
        audiR8Gallery08,
        audiR8Gallery09,
        audiR8Gallery10,
      ],
    },
  },
  {
    id: "ferrari-296-gts",
    name: "FERRARI 296 GTS",
    brand: "Ferrari",
    specs: {
      year: 2023,
      mileage: 1500,
      gearbox: "Automatique",
      fuel: "Essence",
      engine: "3.0L V6 hybride",
      powerHP: 830,
      powerCV: 45,
      exteriorColor: "Rosso Corsa",
      interiorColor: "Cuir beige",
    },
    features: commonFeatures,
    price: buildRentalPrice(2200, 150),
    images: {
      main: ferrari296Main,
      gallery: [
        ferrari296Gallery02,
        ferrari296Gallery03,
        ferrari296Gallery04,
        ferrari296Gallery05,
        ferrari296Gallery06,
      ],
    },
  },
  {
    id: "mercedes-g800-brabus",
    name: "MERCEDES G800 BRABUS",
    brand: "Mercedes",
    specs: {
      year: 2023,
      mileage: 1200,
      gearbox: "Automatique",
      fuel: "Essence",
      engine: "4.0L V8 biturbo BRABUS",
      powerHP: 800,
      powerCV: 44,
      exteriorColor: "Noir Obsidienne",
      interiorColor: "Cuir noir",
    },
    features: {
      ...commonFeatures,
      exterior: [
        ...commonFeatures.exterior,
        "Kit carrosserie BRABUS",
        "Échappement BRABUS",
      ],
    },
    price: buildRentalPrice(2000, 150),
    images: {
      main: mercedesG800Main,
      gallery: [
        mercedesG800Gallery02,
        mercedesG800Gallery03,
        mercedesG800Gallery04,
        mercedesG800Gallery05,
        mercedesG800Gallery06,
        mercedesG800Gallery07,
        mercedesG800Gallery08,
        mercedesG800Gallery09,
      ],
    },
  },
  {
    id: "lamborghini-urus",
    name: "LAMBORGHINI URUS",
    brand: "Lamborghini",
    specs: {
      year: 2023,
      mileage: 2100,
      gearbox: "Automatique",
      fuel: "Essence",
      engine: "4.0L V8 biturbo",
      powerHP: 650,
      powerCV: 36,
      exteriorColor: "Giallo Auge",
      interiorColor: "Cuir noir",
    },
    features: commonFeatures,
    price: buildRentalPrice(2000, 150),
    images: {
      main: lamboUrusMain,
      gallery: [
        lamboUrusGallery02,
        lamboUrusGallery03,
        lamboUrusGallery04,
        lamboUrusGallery05,
        lamboUrusGallery06,
      ],
    },
  },
  {
    id: "lamborghini-revuelto",
    name: "LAMBORGHINI REVUELTO",
    brand: "Lamborghini",
    specs: {
      year: 2025,
      mileage: 900,
      gearbox: "Automatique",
      fuel: "Hybride",
      engine: "6.5L V12 hybride rechargeable",
      powerHP: 1015,
      powerCV: 56,
      exteriorColor: "Arancio Apodis",
      interiorColor: "Cuir noir et orange",
    },
    features: {
      ...commonFeatures,
      other: [...commonFeatures.other, "Mode Corsa", "Launch control"],
    },
    price: buildRentalPrice(3200, 120),
    images: {
      main: lamboRevueltoMain,
      gallery: [
        lamboRevueltoGallery02,
        lamboRevueltoGallery03,
        lamboRevueltoGallery04,
        lamboRevueltoGallery05,
        lamboRevueltoGallery06,
        lamboRevueltoGallery07,
        lamboRevueltoGallery08,
        lamboRevueltoGallery09,
        lamboRevueltoGallery10,
      ],
    },
  },
  {
    id: "lambo-huracan-evo-spyder",
    name: "LAMBO HURACAN EVO SPYDER",
    brand: "Lamborghini",
    specs: {
      year: 2023,
      mileage: 1800,
      gearbox: "Automatique",
      fuel: "Essence",
      engine: "5.2L V10",
      powerHP: 640,
      powerCV: 35,
      exteriorColor: "Verde Mantis",
      interiorColor: "Cuir noir",
    },
    features: commonFeatures,
    price: buildRentalPrice(2200, 150),
    images: {
      main: lamboHuracanMain,
      gallery: [
        lamboHuracanGallery02,
        lamboHuracanGallery03,
        lamboHuracanGallery04,
        lamboHuracanGallery05,
        lamboHuracanGallery06,
        lamboHuracanGallery07,
      ],
    },
  },
  {
    id: "abarth-500-noir",
    name: "ABARTH 500 NOIR",
    brand: "Abarth",
    specs: {
      year: 2024,
      mileage: 6400,
      gearbox: "Automatique",
      fuel: "Essence",
      engine: "1.4L T-Jet",
      powerHP: 180,
      powerCV: 10,
      exteriorColor: "Noir/Gris Nardo",
      interiorColor: "Cuir noir",
    },
    features: commonFeatures,
    price: buildRentalPrice(250, 200),
    images: {
      main: abarth500Main,
      gallery: [
        abarth500Gallery02,
        abarth500Gallery03,
        abarth500Gallery04,
        abarth500Gallery05,
        abarth500Gallery06,
        abarth500Gallery07,
        abarth500Gallery08,
        abarth500Gallery09,
        abarth500Gallery10,
        abarth500Gallery11,
        abarth500Gallery12,
        abarth500Gallery13,
        abarth500Gallery14,
        abarth500Gallery15,
        abarth500Gallery16,
        abarth500Gallery17,
      ],
    },
  },
];
